import { render } from "./InvoicesPage.vue?vue&type=template&id=e490d66c&ts=true"
import script from "./InvoicesPage.ts?vue&type=script&lang=ts"
export * from "./InvoicesPage.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__